import React, { useState } from "react"
import { SingleDatePicker } from "react-dates"
import { isInclusivelyBeforeDay } from "react-dates"
import moment from "moment-timezone"
import { copyDateTime } from "../../../state/helpers/dateHelpers"


type OwnProps = {
    date: string,
    setDate: (string) => void,

    focused?: boolean,
    futureDatesDisabled?: boolean
}

const InlineDatePickerComponent = (props: OwnProps) => {
    const [focused, setFocused] = useState(props.focused)

    return (
        <div className="w-100 m-0">
            <SingleDatePicker
                small
                block
                displayFormat="LL"
                isOutsideRange={day => 
                    props.futureDatesDisabled ? !isInclusivelyBeforeDay(day, moment()) : false 
                }
                onDateChange={(d) => props.setDate(copyDateTime(d))}
                onFocusChange={({focused}) => setFocused(focused)}
                focused={focused}
                date={props.date ? moment(props.date) : null}
                numberOfMonths={1}
            />
        </div>
    )
}


export default InlineDatePickerComponent


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/InlineDatePickerComponent.tsx